import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  SwipeableDrawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  ListSubheader,
} from '@mui/material';
import {
  Menu as MenuIcon,
  Dashboard as DashboardIcon,
  Brightness4 as Brightness4Icon,
  Brightness7 as Brightness7Icon,
  Info as InfoIcon,
  VideogameAsset as VideogameAssetIcon,
} from '@mui/icons-material';

const drawerWidth = 250;
const NavbarMenu = ({ toggleTheme, darkMode, setSelectedText }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const menuItems = [
    { subheader: 'Menu Utama' },
    { text: 'Home', link: '/admin/dashboard', icon: <DashboardIcon />, divider: false },
    { divider: true },
    { subheader: 'Tambah Data' },
    { text: 'Honkai Star Rail', link: '/admin/honkai-star-rail', icon: <VideogameAssetIcon />, divider: false },
    { text: 'Genshin Impact', link: '/admin/genshin-impact', icon: <VideogameAssetIcon />, divider: false },
    { divider: true },
    { subheader: 'Lainnya' },
    { text: 'Logout', link: '/logout', icon: <InfoIcon />, divider: false },
  ];
  
  const drawerContent = (
    <Box
      sx={{ width: drawerWidth }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        {menuItems.map((item, index) =>
          item.subheader ? (
            <ListSubheader key={index} sx={{ backgroundColor: 'inherit', color: 'text.secondary' }}>
              {item.subheader}
            </ListSubheader>
          ) : item.divider ? (
            <Divider key={index} />
          ) : (
            <ListItem
              button
              key={index}
              component={Link}
              to={item.link}
              onClick={() => setSelectedText(item.text)}
              sx={{
                '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.08)' },
                paddingLeft: 2,
                paddingRight: 2,
                color: 'text.primary',
              }}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItem>
          )
        )}
      </List>
    </Box>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed">
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <IconButton
            size="medium"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{ mr: 2 }}
            onClick={toggleDrawer(true)}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ display: { xs: 'block', sm: 'block' } }}
          > </Typography>
          <IconButton
            color="inherit"
            onClick={toggleTheme}
          >
            {darkMode ? <Brightness7Icon /> : <Brightness4Icon />}
          </IconButton>
        </Toolbar>
      </AppBar>
      <Toolbar />
      <SwipeableDrawer
        anchor="left"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
      >
        {drawerContent}
      </SwipeableDrawer>
    </Box>
  );
};

export default NavbarMenu;
